//Import librairies for frontoffice
// require('./lib/frontend');

import swal from 'sweetalert2';
window.swal = swal